import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#34495E] border-t border-heaven-gold/10 py-12 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-left">
            <Link to="/" className="block mb-4">
              <img 
                src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//tranparent%20logo.png" 
                alt="Selah Logo" 
                className="h-14 md:h-20 max-h-20 object-contain transition-all duration-300" 
              />
            </Link>
            <p className="text-white/80 text-sm mb-4">
              Bridging Biblical wisdom with modern technology to provide personalized, 
              scripture-based guidance for your spiritual journey.
            </p>
          </div>
          
          <div className="text-left">
            <h3 className="text-heaven-gold font-semibold mb-4">FEATURES</h3>
            <ul className="space-y-2">
              <li><Link to="/bible-tools" className="text-white/80 hover:text-heaven-gold text-sm">Find Your Verse</Link></li>
              <li><Link to="/prayer-generator" className="text-white/80 hover:text-heaven-gold text-sm">Prayer Generator</Link></li>
              <li><Link to="/bible-tools" className="text-white/80 hover:text-heaven-gold text-sm">Scripture Tools</Link></li>
              <li><Link to="/ministry" className="text-white/80 hover:text-heaven-gold text-sm">Ministry Resources</Link></li>
            </ul>
          </div>
          
          <div className="text-left">
            <h3 className="text-heaven-gold font-semibold mb-4">RESOURCES</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/80 hover:text-heaven-gold text-sm">Bible Studies</Link></li>
              <li><Link to="/" className="text-white/80 hover:text-heaven-gold text-sm">Sermon Prep</Link></li>
              <li><Link to="/" className="text-white/80 hover:text-heaven-gold text-sm">Youth Events</Link></li>
              <li><Link to="/apologetics" className="text-white/80 hover:text-heaven-gold text-sm">Apologetics</Link></li>
            </ul>
          </div>
          
          <div className="text-left">
            <h3 className="text-heaven-gold font-semibold mb-4">COMPANY</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-white/80 hover:text-heaven-gold text-sm">About Us</Link></li>
              <li><Link to="/terms" className="text-white/80 hover:text-heaven-gold text-sm">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-white/80 hover:text-heaven-gold text-sm">Privacy Policy</Link></li>
              <li><Link to="/" className="text-white/80 hover:text-heaven-gold text-sm">Pricing</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-10 pt-6 border-t border-heaven-gold/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/80 text-sm">© {currentYear} Selah. All rights reserved.</p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/" className="text-white/80 hover:text-heaven-gold">Twitter</Link>
            <Link to="/" className="text-white/80 hover:text-heaven-gold">Facebook</Link>
            <Link to="/" className="text-white/80 hover:text-heaven-gold">Instagram</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
